export const haafPaymentKeys = {
  all: ["haafPayments"],
  lists: () => [...haafPaymentKeys.all, "list"],
  list: () => [...haafPaymentKeys.lists()],
  chapterList: () => [...haafPaymentKeys.lists(), "chapter"],
  batchList: (batch) => [...haafPaymentKeys.lists(), "batch", batch],
  stats: () => [...haafPaymentKeys.lists(), "stats"],
  batchStats: () => [...haafPaymentKeys.lists(), "batchStats"],
  chapterStats: () => [...haafPaymentKeys.lists(), "chapterStats"],
  details: () => [...haafPaymentKeys.all, "detail"],
  detail: (id) => [...haafPaymentKeys.details(), id],
};
